import axios from 'axios';

const rawApiUrl = process.env.REACT_APP_API_URL;
const API_URL = rawApiUrl && rawApiUrl.endsWith('/api') ? rawApiUrl : `${rawApiUrl}/api`;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const getSiteSettings = async () => {
  try {
    const response = await axiosInstance.get('/MainPageSettings/GetSiteSettings');
    return response.data;
  } catch (error) {
    console.error('Error fetching site settings:', error);
    throw error;
  }
};
